/**
 * The "Offer in the support ticket form" switch on an application
 * (org-admin#172, RidgeWill/auth#573).
 *
 * Whether customers can pick an app when filing a ticket is its own setting,
 * never worked out from the status: moving an app to alpha does not list it,
 * so the day it appears is a decision. What the portal adds is a reminder when
 * the two look out of step, and nothing more.
 */

/** The stages at which an app is in front of people outside the team. */
const OUT_TO_PEOPLE = new Set(['alpha', 'beta', 'live']);

/**
 * Should the settings form remind the admin that this app is not offered?
 *
 * Only for an app at alpha or later with the switch off. A nudge, not a rule:
 * the setting is never flipped for them, because an app can legitimately be in
 * alpha with its testers reporting from inside the app alone.
 */
export function suggestsListing(status: string, supportListed: boolean): boolean {
  return OUT_TO_PEOPLE.has(status) && !supportListed;
}
